(function(){
  if (window.__pfHome) return; window.__pfHome = true;

  // Reveal on scroll
  function initReveal(root){
    var els = (root||document).querySelectorAll('.pf-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target);} });
    }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  // Quick add to cart -> opens theme cart drawer
  document.addEventListener('submit', function(ev){
    var form = ev.target;
    if (!form.matches || !form.matches('form[data-pf-quick-add]')) return;
    ev.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy','true'); btn.textContent = 'Adding…'; }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] };
    if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)
    }).then(function(r){ return r.json(); }).then(function(res){
      if (res.status && res.status >= 400) throw new Error(res.description || 'Error');
      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        try { drawer.renderContents(res); } catch(e){ window.location.href = '/cart'; }
      } else { window.location.href = '/cart'; }
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(function(){ btn.innerHTML = label; btn.removeAttribute('aria-busy'); }, 1600); }
    }).catch(function(err){
      if (btn) { btn.textContent = 'Unavailable'; setTimeout(function(){ btn.innerHTML = label; btn.removeAttribute('aria-busy'); }, 1800); }
    });
  });

  // Tabs (product grid)
  document.addEventListener('click', function(ev){
    var tab = ev.target.closest('[data-pf-tab]');
    if (!tab) return;
    var root = tab.closest('[data-pf-tabs]');
    root.querySelectorAll('[data-pf-tab]').forEach(function(t){ t.setAttribute('aria-selected', t===tab ? 'true':'false'); });
    root.querySelectorAll('[data-pf-panel]').forEach(function(p){ p.hidden = p.getAttribute('data-pf-panel') !== tab.getAttribute('data-pf-tab'); });
    initReveal(root);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initReveal(); });
  else initReveal();
  document.addEventListener('shopify:section:load', function(e){ initReveal(e.target); });
})();
